import { useAppSelector } from "../../Redux/hooks";
import { callSubscriptionCheckout } from "../../Services/Serverless/callSubscriptionURL";

export default function Subscribe() {
  const token = useAppSelector((state) => state.auth.token);
  const handleSubscribe = () => {
    if (token === null) return;
    callSubscriptionCheckout(token.accessToken).then((response) => {
      console.log(response);
      window.location.href = response.url;
    });
  };
  if (token === null) return <div>Loading Token</div>;
  return (
    <div>
      <button onClick={handleSubscribe}>Subscribe</button>
    </div>
  );
}
